import { render, staticRenderFns } from "./ccv-pie-chart.vue?vue&type=template&id=4aa9c40b&"
import script from "./ccv-pie-chart.vue?vue&type=script&lang=js&"
export * from "./ccv-pie-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports